
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
/**
- List containing label and value
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralListCard',
  components: {
    EuCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'interactive'
    },
    /**
     * Set list of items:
     * `label` for left text <br />
     * `value` for right text <br />
     */
    listItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Method to click card
       *  @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
